import React, { Suspense, lazy, useEffect, useState } from "react";
import { FallingLines } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import logo from "../../assets/icons/Fameo-X-App-icon.png";
// import logo from "../../assets/icons/white Logo-1.png";
import Loading from "../../components/Hooks/Loading";
import axios from "../../components/Hooks/axios";
import styles from "./ChoseTemplate.module.scss";

const ImageComponent = lazy(() => import("./ImageComponent"));

const STATIC_TEMPLATES = [
  {
    _id: "64e369b0c5b49890c7da330d",
    name: "Template1",
    route: "64e369b0c5b49890c7da330d",
    thumbnail: "https://firebasestorage.googleapis.com/v0/b/fameox.firebasestorage.app/o/Template_View%2FFrame%20685.png?alt=media&token=663c40be-f4c2-4e42-8c2b-2ce9f2bf0862",
  },
  {
    _id: "64e8f2c3b9b30c1ed4b28bb6",
    name: "Template2",
    route: "64e8f2c3b9b30c1ed4b28bb6",
    thumbnail: "https://firebasestorage.googleapis.com/v0/b/fameox.firebasestorage.app/o/Template_View%2FFrame%20682.png?alt=media&token=bffd456f-5c24-46f3-94d0-19c453ac719a",
  },
  {
    _id: "64ec9d9bb9b30c1ed4b48bcc",
    name: "Template3",
    route: "64ec9d9bb9b30c1ed4b48bcc",
    thumbnail: "https://firebasestorage.googleapis.com/v0/b/fameox.firebasestorage.app/o/Template_View%2FFrame%20686.png?alt=media&token=1122c6fb-62bd-4319-9801-769f0af0ed6b",
  },
  {
    _id: "64ec9dafb9b30c1ed4b48bd9",
    name: "Template4",
    route: "64ec9dafb9b30c1ed4b48bd9",
    thumbnail: "https://firebasestorage.googleapis.com/v0/b/fameox.firebasestorage.app/o/Template_View%2FFrame%20688.png?alt=media&token=fd0d11cf-d730-409a-949b-b41fd1a925b7",
  },
  {
    _id: "64ec9dbcb9b30c1ed4b48be6",
    name: "Template5",
    route: "64ec9dbcb9b30c1ed4b48be6",
    thumbnail: "https://firebasestorage.googleapis.com/v0/b/fameox.firebasestorage.app/o/Template_View%2FFrame%20689.png?alt=media&token=2eae1e99-a230-4be5-89ab-a976ab2b6567",
  },
  {
    _id: "64ec9dc9b9b30c1ed4b48bf3",
    name: "Template6",
    route: "64ec9dc9b9b30c1ed4b48bf3",
    thumbnail: "https://firebasestorage.googleapis.com/v0/b/fameox.firebasestorage.app/o/Template_View%2FFrame%20683.png?alt=media&token=b88f374f-04b1-48a9-a274-877033bb4599",
  },
  {
    _id: "64ec9f75b9b30c1ed4b48c04",
    name: "Template7",
    route: "64ec9f75b9b30c1ed4b48c04",
    thumbnail: "https://firebasestorage.googleapis.com/v0/b/fameox.firebasestorage.app/o/Template_View%2FFrame%20680.png?alt=media&token=b0317f20-67c1-4e91-96a0-8e515106b0b1",
  },
  {
    _id: "64eca015b9b30c1ed4b48c13",
    name: "Template8",
    route: "64eca015b9b30c1ed4b48c13",
    thumbnail: "https://firebasestorage.googleapis.com/v0/b/fameox.firebasestorage.app/o/Template_View%2FFrame%20681.png?alt=media&token=1c78bd9f-0833-4dff-bc73-57aad675d159",
  },
  {
    _id: "64eca333b9b30c1ed4b48fd7",
    name: "Template9",
    route: "64eca333b9b30c1ed4b48fd7",
    thumbnail: "https://firebasestorage.googleapis.com/v0/b/fameox.firebasestorage.app/o/Template_View%2FFrame%20684.png?alt=media&token=da7dbdb1-a194-4433-947d-db6b9d4a6825",
  },
  {
    _id: "64eca4efb9b30c1ed4b48fe4",
    name: "Template10",
    route: "64eca4efb9b30c1ed4b48fe4",
    thumbnail: "https://firebasestorage.googleapis.com/v0/b/fameox.firebasestorage.app/o/Template_View%2FFrame%20687.png?alt=media&token=4dfd8a0f-6db6-4b6e-8e99-cce2a7e15e18",
  },
  {
    _id: "6515ba64f8dd97fbff6724b8",
    name: "Template11",
    route: "6515ba64f8dd97fbff6724b8",
    thumbnail: "https://firebasestorage.googleapis.com/v0/b/fameox.firebasestorage.app/o/Template_View%2FFrame%20691.png?alt=media&token=0248de81-bf07-4386-a795-c66633bc984d",
  },
  {
    _id: "6515bbf5f8dd97fbff672532",
    name: "Template12",
    route: "6515bbf5f8dd97fbff672532",
    thumbnail: "https://firebasestorage.googleapis.com/v0/b/fameox.firebasestorage.app/o/Template_View%2FFrame%20692.png?alt=media&token=25376a84-a1b1-4665-b646-3c04d782eab2",
  },
  {
    _id: "6532ada423d177ec023fe738",
    name: "Template13",
    route: "6532ada423d177ec023fe738",
    thumbnail: "https://firebasestorage.googleapis.com/v0/b/fameox.firebasestorage.app/o/Template_View%2FFrame%20694.png?alt=media&token=49ac771b-ac64-4d2e-ab2b-3b5424a05034",
  },
  {
    _id: "6532afa623d177ec023fe747",
    name: "Template14",
    route: "6532afa623d177ec023fe747",
    thumbnail: "https://firebasestorage.googleapis.com/v0/b/fameox.firebasestorage.app/o/Template_View%2FFrame%20693.png?alt=media&token=2bf553ef-c74b-4936-9d41-0f3f3642b5cf",
  },
  {
    _id: "6532b24523d177ec023fe75c",
    name: "Template15",
    route: "6532b24523d177ec023fe75c",
    thumbnail: "https://firebasestorage.googleapis.com/v0/b/fameox.firebasestorage.app/o/Template_View%2FFrame%20695.png?alt=media&token=d0a6452f-b921-4c78-8d11-e3f71a2242a6",
  },
];

const ChoseTemplate = () => {
  const navigate = useNavigate();
  const { userId, user, token } = useSelector((state) => state.auth);
  const [activeBtn, setActiveBtn] = useState("Personal");
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [activeTemplate, setActiveTemplate] = useState("");
  const [templateData, setTemplateData] = useState(STATIC_TEMPLATES);
  const [isLoading, setIsLoading] = useState(false);

  const handelYes = () => {
    const data = JSON.stringify({
      userId,
      templateId: activeTemplate?._id,
    });

    axios
      .post("/persona/user-template", data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(() => {
        toast.success("Template Chose Successfully");
        navigate("/PersonaRedirect", { replace: true });
      })
      .catch(({ response }) => {
        console.log(response);
      });
  };

  useEffect(() => {
    if (user?.accountType === "professional" || user?.accountType === "business") {
      setActiveBtn("Business");
    } else if (user?.accountType === "personal") {
      setActiveBtn("Personal");
    }
  }, [user]);

  useEffect(() => {
    setIsLoading(true);
    setTemplateData(STATIC_TEMPLATES);
    setIsLoading(false);
  }, [activeBtn]);

  return (
    <div className={styles.ChoseTemplate}>
      <div className={styles.Top}>
        <div className={styles.Left}>
          <img src={logo} alt="" />
          <div>
            <h3>Choose Your Persona</h3>
            <h4>Please choose your Persona </h4>
          </div>
        </div>

        <div className={styles.Right}>
          {user?.accountType === "personal" && (
            <button
              className={activeBtn === "Personal" ? styles.active : ""}
              onClick={() => setActiveBtn("Personal")}
            >
              Personal
            </button>
          )}
          {(user?.accountType === "business" || user?.accountType === "professional") && (
            <button
              className={activeBtn === "Business" ? styles.active : ""}
              onClick={() => setActiveBtn("Business")}
            >
              Business
            </button>
          )}
        </div>

        <div className={styles.BackBtn} onClick={() => navigate(-1)}>
          {"<"}
        </div>
      </div>

      <Suspense fallback={<Loading />}>
        <div className={styles.Bottom}>
          {templateData.map((data, index) => (
            <ImageComponent
              key={index}
              {...{ data, token, setConfirmPopup, setActiveTemplate, index }}
            />
          ))}
        </div>
      </Suspense>

      <div className={styles.loadingContainer}>
        {isLoading && (
          <FallingLines
            color="#3A0DBB"
            width="100"
            visible={true}
            ariaLabel="falling-lines-loading"
          />
        )}
      </div>

      {confirmPopup && (
        <div className={styles.PopupContainer}>
          <div className={styles.Popup}>
            <div className={styles.TopPopup}>
              <h1>Do you want to use this persona ?</h1>
              <h2>You can always change your persona later</h2>
            </div>
            <div className={styles.BottomPopup}>
              <button onClick={handelYes}>Yes</button>
              <button
                onClick={() => {
                  setConfirmPopup(false);
                  setActiveTemplate("");
                }}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChoseTemplate;


